import { __ } from '../../utils';
import { HeaderIconButton } from '../Header/HeaderIconButton';
import NotificationsList from './NotificationsList';
import { Divider, Drawer, Stack, Typography } from '@presov.sk/presov-ui-react';
import { Settings } from '@mui/icons-material';
import React from 'react';
import { Link } from 'react-router';

type Props = {
  isOpen: boolean;
  onClose?: () => void;
};

const NotificationsDrawer: React.FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      anchor='right'
      sx={{
        display: {
          md: 'none',
        },
      }}
    >
      <Stack
        sx={{
          width: '85vw',
        }}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          sx={{
            padding: 1.5,
            position: 'sticky',
            top: 0,
            background: (theme) => theme.palette.primary.main,
            zIndex: 1000,
          }}
        >
          <Typography
            variant='h5'
            sx={{
              color: (theme) => theme.palette.primary.contrastText,
            }}
          >
            {__('Notifikácie')}
          </Typography>
          <Link to='/profil/nastavenia'>
            <HeaderIconButton onClick={onClose}>
              <Settings
                sx={{
                  color: (theme) => theme.palette.primary.contrastText,
                }}
              />
            </HeaderIconButton>
          </Link>
        </Stack>
        <Divider />
        <NotificationsList onClose={onClose} />
      </Stack>
    </Drawer>
  );
};

export default NotificationsDrawer;
